import type React from 'react';

import PropTypes from 'prop-types';

import type { TBaseConstructor } from './_wrapper';

export function mixinContextMembers<TBase extends TBaseConstructor>(Base: TBase) {
    return class extends Base {
        static contextTypes = {
            basePath: PropTypes.string.isRequired,
            prefix: PropTypes.string.isRequired,
            staticUrls: PropTypes.object.isRequired,
        };

        context!: React.ContextType<
            React.Context<{
                staticUrls: Record<string, string>;
                basePath: string;
                prefix: string;
            }>
        >;
    };
}
